module.exports = __webpack_public_path__ + "img/live-2.d2d05ce2.png";